import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { MarkupField } from '~src/spacesPlatform/components/Explorer/widgets/MarkupField';
import { Name } from '~src/spacesPlatform/components/tooltip/Name';
import { RelatedEntity } from '~src/spacesPlatform/components/tooltip/RelatedEntity';
import { Timestamp } from '~src/spacesPlatform/components/tooltip/Timestamp';
import { Tooltip } from '~src/spacesPlatform/components/tooltip/Tooltip';
import { ContentTooltipProps, getProjectLink, TooltipDescriptionTestId } from '~src/spacesPlatform/components/tooltip/TooltipHelper';
import { User } from '~src/spacesPlatform/components/tooltip/User';

import { Messages } from '../../../codegen/Localize';
import { IPredictiveModelInfo } from '../../models/IPredictiveModelInfo';

export function PredictiveModelTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, contentUrl, urls } = props;
  const projectLink = getProjectLink((props.content as IPredictiveModelInfo).project, urls);

  return (
    <Tooltip>
      <Name name={content.name} url={contentUrl}/>
      <MarkupField markup={props.content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]}/>
      <dl className={DetailsTooltipStyles.DescriptionList}>
        {!props.inProjectSpace && <RelatedEntity label={Messages.project()} link={projectLink}/>}
        <User user={props.content.owner} label={Messages.owner()} urls={urls}/>
        <Timestamp label={Messages.modified()} value={props.content.updatedAt}/>
      </dl>
    </Tooltip>
);
}
